import React, { useMemo } from 'react';
import { categoriesList, CategoryType } from 'constants/categoriesList';
import { CategoryComponents } from '@app/components/header/components/HeaderSearch/HeaderSearch';
import { CATEGORY_ICON, CATEGORY_LABEL } from '@app/constants/categoryIcons';
import * as S from './SearchFilter.styles';
import { BaseCol } from '@app/components/common/BaseCol/BaseCol';
import { BaseRow } from '@app/components/common/BaseRow/BaseRow';

interface SearchFilterProps {
  data: CategoryComponents[] | null;
  isOpen: boolean;
  selectedCategories: CategoryType[];
  onCategoryChange: (cats: CategoryType[]) => void;
  children: (filteredResults: CategoryComponents[]) => React.ReactNode;
}

export const SearchFilter: React.FC<SearchFilterProps> = ({
  data,
  isOpen,
  selectedCategories,
  onCategoryChange,
  children,
}) => {
  const filterElements = useMemo(
    () =>
      categoriesList.map((filter, index) => (
        <BaseCol key={index} xs={12} sm={8} md={12} xl={8}>
          <S.CheckBox value={filter.name}>
            <span className="cat-label">
              {CATEGORY_ICON[filter.name]}
              {CATEGORY_LABEL[filter.name] ?? filter.name}
            </span>
          </S.CheckBox>
        </BaseCol>
      )),
    [],
  );

  const filteredResults = useMemo(() => {
    if (!data) return [];
    if (selectedCategories.length === 0) return data;
    return data.filter((cat) => selectedCategories.includes(cat.category));
  }, [data, selectedCategories]);

  return (
    <>
      <S.FilterWrapper isOpen={isOpen}>
        <S.CheckboxGroup
          value={selectedCategories}
          onChange={(vals) => onCategoryChange(vals as CategoryType[])}
        >
          <BaseRow>{filterElements}</BaseRow>
        </S.CheckboxGroup>
      </S.FilterWrapper>

      {data !== null && children(filteredResults)}
    </>
  );
};
